import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black pb-6" }, "Time of day contacts should move to next action", -1)

import { watch } from "vue"
import { ClockIcon } from "@heroicons/vue/outline"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsRadioSelect from "@/components/GgmsRadioSelect.vue"
import { useWorkflowStore } from "@/stores/workflow"
import { dateTimeConverter } from "@/shared/utils/helpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeOfDayComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

const radioButtonsOptions = [
    { displayName: "Use account time zone (EST)", value: "account" },
    { displayName: "Use contact time zone", value: "contact" },
]

watch(
    () => workflowStore.modelValue.time,
    () => {
        //convert time into ISO date
        if (workflowStore.modelValue.time) {
            workflowStore.modelValue.dateTime = dateTimeConverter(workflowStore.modelValue.time)
        }
    }
)

watch(
    () => [workflowStore.modelValue.time, workflowStore.modelValue.event],
    () => {
        workflowStore.areButtonDisabled = !(workflowStore.modelValue.time && workflowStore.modelValue.event)
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GgmsInput, {
      modelValue: _unref(workflowStore).modelValue.time,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.time) = $event)),
      label: "Time of day",
      type: "time",
      iconStart: _unref(ClockIcon)
    }, null, 8, ["modelValue", "iconStart"]),
    _createVNode(GgmsRadioSelect, {
      modelValue: _unref(workflowStore).modelValue.event,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event)),
      options: radioButtonsOptions
    }, null, 8, ["modelValue"])
  ]))
}
}

})